export default __webpack_public_path__ + "static/media/FeministConnection.891a8fe5.pdf";